import api from '@/services/Api';
import { successSwal, warningSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { AxiosResponse } from 'axios';
import ImpfDbImpfstoff, { ImpfDbImpfstoffEdit } from '@/types/ImpfDbImpfstoff';
import { ImpfDbState, RootState } from '@/store/types';

type Context = ActionContext<ImpfDbState, RootState>;

export const impfdb: Module<ImpfDbState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            impfstoffe: false,
        },
        impfstoffe: [],
    },
    actions: {
        loadImpfstoffe({ commit }: Context): void {
            commit('setLoadersImpfstoffe', true);

            api.post('verwaltung/impfdbimpfstoffe/load')
                .then((response: AxiosResponse) => commit('setImpfstoffe', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersImpfstoffe', false));
        },
        updateImpfstoff({ commit, dispatch }: Context, payload: ImpfDbImpfstoffEdit): void {
            commit('setLoadersSave', true);

            api.post('verwaltung/impfdbimpfstoffe/speichern', payload)
                .then((response: AxiosResponse) => {
                    if (typeof response.data.body !== 'string') {
                        successSwal('Impfstoff', 'gespeichert');
                        dispatch('loadImpfstoffe');
                        commit('setDialogsDetail', false);
                    } else {
                        warningSwal('Warnung', response.data.body ?? 'Dieser Impfstoff kann nicht bearbeitet werden.');
                    }
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteImpfstoff({ commit, dispatch }: Context, payload: ImpfDbImpfstoffEdit): void {
            commit('setLoadersDelete', true);

            api.post('verwaltung/impfdbimpfstoffe/loeschen', payload)
                .then((response: AxiosResponse) => {
                    if (typeof response.data.body !== 'string') {
                        successSwal('Impfstoff', 'gelöscht');
                        dispatch('loadImpfstoffe');
                        commit('setDialogsDetail', false);
                    } else {
                        warningSwal('Warnung', response.data.body ?? 'Dieser Impfstoff ist nicht löschbar.');
                    }
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
    },
    mutations: {
        setImpfstoffe(state: ImpfDbState, payload: Partial<ImpfDbImpfstoff>[]): void {
            state.impfstoffe = payload.map((data) => new ImpfDbImpfstoff(data));
        },
        setDialogsDetail(state: ImpfDbState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: ImpfDbState, visible: boolean): void {
            state.loaders.save = visible;
        },
        setLoadersDelete(state: ImpfDbState, visible: boolean): void {
            state.loaders.delete = visible;
        },
        setLoadersImpfstoffe(state: ImpfDbState, visible: boolean): void {
            state.loaders.impfstoffe = visible;
        },
    },
};
